import * as Highcharts from "highcharts";
// chart with 2 lines

export const chartData = {
  credits: { enabled: false },
  chart: { zoomType: "xy" },
  title: {
    text: ""
  },
  xAxis: [
    {
      categories: [
        "1Jul",
        "2Jul",
        "3Jul",
        "4Jul",
        "5Jul",
        "6Jul",
        "7Jul",
        "8Jul",
        "9Jul",
        "10Jul",
        "11Jul"
      ],
      crosshair: true
    }
  ],
  yAxis: [
    {
      // Primary yAxis
      labels: {
        style: { fontSize: "12px" },

        format: "{value}%"
      },
      title: {
        text: "SLA"
      },
      min:0,
      max:125
    },
    {
      // Secondary yAxis
      title: {
        text: "Quantity"
      },
      labels: {
        style: { fontSize: "12px" },

        format: "{value}"
      },
      opposite: true
    }
  ],
  tooltip: { shared: true },
  plotOptions: {
    line: {
      lineWidth: 2,
      dataLabels: {
        enabled: true,
        formatter: function() {
          if (this.point.x == this.series.data.length - 1) {
            return `Target (${this.y}%)`;
          }
        },
        style: {
          color: "#626262",
          fontSize: "12px",
          fontWeight: "normal"
        }
      },
      enableMouseTracking: true,
      marker: {
        enabled: false
      }
    }
  },
  legend: {
    enabled: true,
    itemMarginTop: 10,
    itemMarginBottom: -20,
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal"
    }
  },
  series: [
    {
      name: "Percentage",
      type: "line",
      data: [49.9, 71.5, 80.4, 92.2, 70.0, 76.0, 35.6, 48.5, 86.4, 94.1, 95.6],
      tooltip: { valueSuffix: "%" },
      color: "#3985df",
      dataLabels: {
        enabled: false
      }
    },
    {
      name: "Volume",
      type: "line",
      yAxis: 1,
      data: [7.0, 6.9, 9.5, 14.5, 18.2, 21.5, 25.2, 26.5, 23.3, 18.3, 13.9],
      color: "#909dc0",
      dataLabels: {
        enabled: false
      }
    },
    {
      type: "line",
      name: "Target",
      showInLegend: false,
      data: [0, 0, 0],
      dashStyle: "ShortDash",
      color: "#979797",
      enableMouseTracking: false,
      
    }
  ]
};
